import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// Components
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import ServiceDetail from './pages/ServiceDetail';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import Forbidden from './pages/Forbidden';

function App() {
  return (
    <HelmetProvider>
      <div className="flex min-h-screen flex-col bg-sand-50 text-asphalt-900 antialiased">
        {/* Scroll Restoration */}
        <ScrollToTop />

        {/* Header Navigation */}
        <Header />

        {/* Main Content Area */}
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/om-os" element={<About />} />
            <Route path="/ydelser/:slug" element={<ServiceDetail />} />
            <Route path="/galleri" element={<Gallery />} />
            <Route path="/kontakt" element={<Contact />} />
            
            {/* Error Pages */}
            <Route path="/403" element={<Forbidden />} />
            <Route path="/404" element={<NotFound />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </HelmetProvider>
  );
}

export default App;
